import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Avatar,
  Badge,
  Box,
  Card,
  Container,
  Divider,
  Grid2,
  Typography,
} from '@mui/material';
import { Loader } from 'components';
import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useGetBookingDetails } from 'hooks/useBooking';
import { IBPRateBookingDB } from 'types/BookingDetailsV1';
import { config } from 'config/config';
import {
  initialUserSearchState,
  useUserSearchContext,
} from 'context/UserSearchContext';

export const ConfirmedBooking: React.FC = () => {
  const [searchParams] = useSearchParams();
  const locationCode = searchParams.get('locationCode');
  const { setBookingSearchData, loading: bookingSearchDataLoading } =
    useUserSearchContext();
  const navigate = useNavigate();
  const { bookingId } = useParams();

  const {
    data: bookingData,
    isError: getBookingError,
    isLoading: isBookingLoading,
    isSuccess: bookingSuccess,
  } = useGetBookingDetails(bookingId);

  useEffect(() => {
    if (bookingData && bookingSuccess) {
      const timer = setTimeout(() => {
        setBookingSearchData({ ...initialUserSearchState });
        if (!bookingSearchDataLoading) {
          navigate(`/?locationCode=${locationCode}`, { replace: true });
        }
      }, 60 * 1000);
      return () => clearTimeout(timer);
    }
  }, [bookingData, bookingSuccess]);

  if (isBookingLoading) {
    return <Loader />;
  }

  if (getBookingError) {
    return <Box>{String(getBookingError)}</Box>;
  }
  return (
    <Container>
      <Box className="bookingConfirmedMessage">
        <CheckCircleIcon color="primary" />
        <Typography color="primary" component={'p'}>
          {bookingData?.ReservationStatus === 2
            ? 'Congratulations!'
            : bookingData?.ReservationStatus === 0
              ? 'Booking Status!'
              : 'Payment Failed!'}
          <br />
          {bookingData?.ReservationStatus === 2
            ? 'Your booking has been confirmed.'
            : bookingData?.ReservationStatus === 0
              ? 'Your booking is pending.'
              : 'Your payment has failed.'}
        </Typography>
      </Box>
      {isMobile ? (
        <>
          {/* <Typography variant="subtitle2" fontWeight="bold">
              Booking Details
            </Typography>

            <Box
              className="divider"
              component={'hr'}
              sx={{
                margin: '15px 0px',
                backgroundColor: 'lightgray',
                height: '1px',
                width: '100%',
              }}
            ></Box> */}
        </>
      ) : (
        <></>
        // <Grid2 container spacing={2}>
        //   <Grid2 size={{ xs: 6 }}>
        //     <Avatar
        //       variant="square"
        //       src={bookingData.VehicleModel.VehicleImage[0]}
        //       alt={bookingData.VehicleModel.Name}
        //       sx={{
        //         width: '60%',
        //         height: '80%',
        //         borderRadius: 2,
        //       }}
        //     />
        //     <Typography variant="body1" sx={{ marginTop: '10px' }}>
        //       {bookingData.VehicleModel.Name}
        //     </Typography>
        //   </Grid2>

        //   {/* <Grid2
        //     size={{ xs: 6 }}
        //     sx={{
        //       display: 'flex',
        //       flexDirection: 'column',
        //       alignItems: 'end',
        //     }}
        //   >
        //     <QRCodeSVG
        //       value={`${window.location.origin}/confirmed-booking/${bookingId}/${status}`}
        //       width={226}
        //       height={120}
        //       level="H"
        //       title="Booking Details"
        //       marginSize={2}
        //     />
        //     <Typography variant="body2">
        //       Scan QR Code Download Booking Details
        //     </Typography>
        //   </Grid2> */}

        //   <Box
        //     className="divider"
        //     component={'hr'}
        //     sx={{
        //       margin: '15px 0px',
        //       backgroundColor: 'lightgray',
        //       height: '1px',
        //       width: '100%',
        //     }}
        //   ></Box>
        // </Grid2>
      )}
      <Card className="bookingDetail">
        <Typography
          variant="body1"
          sx={{ margin: '10px 0px', textAlign: 'center' }}
        >
          Important Information on Your Rental | Id -{' '}
          {bookingData.ReservationNo}
        </Typography>
        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            margin: '20px 0px',
          }}
        />
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <Grid2 size={{ xs: 6 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ textAlign: 'left !important' }}
              >
                Pickup Details
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {bookingData.OutDetails.BranchName}
              </Typography>
              <Typography variant="body2" fontWeight="bold" mt={1}>
                {bookingData.OutDetails.Date +
                  ', ' +
                  bookingData.OutDetails.Time}
              </Typography>
            </Grid2>
            <Divider
              sx={{
                backgroundColor: 'lightgray',
                height: '1px',
                margin: '20px 0px',
              }}
            />
            <Grid2 size={{ xs: 6 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ textAlign: 'left !important' }}
              >
                Return Details
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {bookingData.InDetails.BranchName}
              </Typography>
              <Typography variant="body2" fontWeight="bold" mt={1}>
                {bookingData.InDetails.Date + ', ' + bookingData.InDetails.Time}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2
            size={{ xs: 6 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'end',
              justifyContent: 'center',
            }}
          >
            <Avatar
              variant="square"
              src={bookingData.VehicleModel.VehicleImage[0]}
              alt={bookingData.VehicleModel.Name}
              sx={{
                width: '60%',
                height: '80%',
                borderRadius: 2,
              }}
            />
            <Typography variant="body1" sx={{ marginTop: '10px' }}>
              {bookingData.VehicleModel.Name} (or similar)
            </Typography>
          </Grid2>
        </Grid2>
      </Card>

      <Card className="bookingDetail">
        <Typography
          variant="body1"
          sx={{ textAlign: isMobile ? 'center' : '' }}
        >
          BOOKING SUMMARY & DETAILS
        </Typography>
        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        />

        <Box className="priceDetail">
          <Typography variant="body1">Price Details</Typography>
          {bookingData &&
            bookingData.RentalRate.map(
              (item: IBPRateBookingDB, index: number) => {
                return (
                  item.Code === 'TAR' && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                      }}
                      key={index}
                    >
                      <Typography variant="body2">{item.Name}</Typography>
                      <Typography variant="body2">
                        AED {item.SubTotal}/{bookingData.PaidDuration}
                        {bookingData.PaidDuration > 1 ? ' Days' : ' Day'}
                      </Typography>
                    </Box>
                  )
                );
              }
            )}
        </Box>

        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        />

        <Box className="priceDetail">
          <Typography variant="body1">Insurance</Typography>
          {bookingData &&
            bookingData.RentalRate.map(
              (item: IBPRateBookingDB, index: number) => {
                return (
                  config.insuranceChargeCode.includes(item.Code) && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                      }}
                      key={index}
                    >
                      <Typography variant="body2">{item.Name}</Typography>
                      <Typography variant="body2">
                        AED {item.SubTotal}/{bookingData.RentalDuration}
                        {bookingData.RentalDuration > 1 ? ' Days' : ' Day'}
                      </Typography>
                    </Box>
                  )
                );
              }
            )}
        </Box>
        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        />

        <Box className="priceDetail">
          <Typography variant="body1">Add-ons/Extras</Typography>
          {bookingData &&
            bookingData.RentalRate.map(
              (item: IBPRateBookingDB, index: number) => {
                return config.ancilarriesChargeCode.includes(item.Code) ||
                  item.Code === 'OWR' ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: '10px',
                    }}
                    key={index}
                  >
                    <Typography variant="body2">{item.Name}</Typography>
                    <Typography variant="body2">
                      {' '}
                      AED {item.SubTotal}/{bookingData.RentalDuration}
                      {bookingData.RentalDuration > 1 ? ' Days' : ' Day'}
                    </Typography>
                  </Box>
                ) : (
                  ''
                );
              }
            )}
        </Box>

        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
          }}
        >
          <Typography variant="body2">VAT (5%)</Typography>
          <Typography variant="body2">
            {' '}
            AED
            {bookingData && (
              <>
                {bookingData.TotalTax}/{bookingData.RentalDuration}
                {bookingData.RentalDuration > 1 ? ' Days' : ' Day'}
              </>
            )}
          </Typography>
        </Box>
        <Divider
          sx={{
            backgroundColor: 'lightgray',
            height: '1px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        />
        {bookingData.OnlinePaymentRef &&
          bookingData.OnlinePaymentStatus >= 0 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '10px',
              }}
            >
              <Typography variant="body2">
                <strong>Payment Status</strong>
              </Typography>
              <Typography variant="body2">
                <strong>
                  {/* // 0 - started, 1- pending, 2 - seccess, 3 - payment failed */}
                  {/* ReservationStatus: number; // 0 - started, 1- pending, 2 - seccess, 3 - payment failed */}
                  {bookingData.OnlinePaymentStatus === 0
                    ? 'Started'
                    : bookingData.OnlinePaymentStatus === 1
                      ? 'Pending'
                      : bookingData.OnlinePaymentStatus === 2
                        ? 'Success'
                        : 'Payment Failed'}
                </strong>
              </Typography>
            </Box>
          )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
          }}
        >
          <Typography variant="body2">
            <strong>Total</strong>
          </Typography>
          <Typography variant="body2">
            <strong>
              AED{' '}
              {bookingData && (
                <>
                  {bookingData.TotalAmount}/{bookingData.RentalDuration}
                  {bookingData.RentalDuration > 1 ? ' Days' : ' Day'}
                </>
              )}
            </strong>
          </Typography>
        </Box>
      </Card>

      <Card className="bookingDetail">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
          }}
        >
          <Typography variant="body2">
            <strong>Payment Method</strong>
          </Typography>
          <Typography variant="body2">
            <strong>
              {bookingData && (
                <>
                  {bookingData.PaymentMethod === 0 &&
                  bookingData.OnlinePaymentStatus >= 0 &&
                  !bookingData.OnlinePaymentRef
                    ? 'Pay At Location'
                    : 'By Credit / Debit Card'}
                </>
              )}
            </strong>
          </Typography>
        </Box>
      </Card>
    </Container>
  );
};
